import Box from '@mui/material/Box';
import { Input } from '../../../../../shared/components/Input';
import { InputDate } from '../../../../../shared/components/InputDate';
import { InputMoney } from '../../../../../shared/components/InputMoney';
import { TabPanel } from '@mui/lab';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { SelectAutoCompleteComponent } from '../../../../../shared/components/SelectAutoCompleteComponent';
import { SelectAutoCompleteOptions } from '../../../../../shared/types/selectAutoComplete';
import { Divider, Typography } from '@mui/material';
import DataTable from '../../../../../shared/components/Table';
import { Button } from '../../../../../shared/components/button/Button';
import { GridColDef } from '@mui/x-data-grid';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';

//import { InputSelect } from '../../../../../shared/components/InputSelect';

const COLUMNS: GridColDef[] = [
    {
        field: 'cpp_parcela_numero',
        headerName: 'Parcela',
        headerAlign: 'center',
        align: 'center',
        width: 200,
    },
    {
        field: 'cpp_valor',
        headerName: 'Valor',
        headerAlign: 'center',
        align: 'center',
        width: 200,
    },
    {
        field: 'cpp_datavencimento',
        headerName: 'Data Vencimento',
        headerAlign: 'center',
        align: 'center',
        width: 200,
        valueFormatter: (params) => {
            if (!params) return '';
            const date = new Date(params);
            return date.toLocaleDateString('pt-BR', { timeZone: 'UTC' });
        },

    }
]

interface TabDadosGeraisProps {
    values: any;
    handleChange: any;
    errors: any;
    touched: any;
    setFieldValue: any;
    activeFornecedorSelected: any;
    FornecedorOptions: SelectAutoCompleteOptions[];
    handleAutoCompleteSelectedFornecedor: (value: SelectAutoCompleteOptions) => void;
    handleSearchFornecedor: (value: string, type: string) => void;

    activeFormaPagamentoSelected: any;
    FormaPagamentoOptions: SelectAutoCompleteOptions[];
    handleAutoCompleteSelectedFormaPagamento: (value: SelectAutoCompleteOptions) => void;
    handleSearchFormaPagamento: (value: string, type: string) => void;
    single: any;
    activeCondicaoParcelamentoSelected: any;
    CondicaoParcelamentoOptions: SelectAutoCompleteOptions[];
    handleAutoCompleteSelectedCondicaoParcelamento: (value: SelectAutoCompleteOptions) => void;
    handleSearchCondicaoParcelamento: (value: string, type: string) => void;
    handleCalculaParcelas: (value: string, type: string) => void;
    duploClick: boolean;
}

export const TabDadosGerais = ({
    values,
    handleChange,
    errors,
    touched,
    setFieldValue,
    activeFornecedorSelected,
    FornecedorOptions,
    handleSearchFornecedor,
    handleAutoCompleteSelectedFornecedor,
    activeFormaPagamentoSelected,
    FormaPagamentoOptions,
    handleSearchFormaPagamento,
    handleAutoCompleteSelectedFormaPagamento,
    activeCondicaoParcelamentoSelected,
    CondicaoParcelamentoOptions,
    handleSearchCondicaoParcelamento,
    handleAutoCompleteSelectedCondicaoParcelamento,
    handleCalculaParcelas,
    duploClick,

}: TabDadosGeraisProps) => {
    return (
        <TabPanel value='1'>
            <form autoComplete='off' onSubmit={() => console.log(values)} name='customer-detail'>
                <fieldset disabled={duploClick}>
                    <Box className='grid grid-cols-12 gap-7 pt-4'>
                        <Input
                            disabled={true}
                            label='Código'
                            className='col-span-1'
                            name='cp_id'
                            type='text'
                            handleChange={handleChange}
                            value={values?.dadosGerais?.cp_id ?? ''}
                        />
                        <Input
                            label='Descrição'
                            className='col-span-5'
                            name='dadosGerais.descricao'
                            type='text'
                            handleChange={handleChange}
                            value={values?.dadosGerais?.descricao ?? ''}
                        />
                        <SelectAutoCompleteComponent
                            label={'Fornecedor *'}
                            value={activeFornecedorSelected?.cli_nome ?? ''}
                            className={'col-span-6'}
                            name={'search'}
                            options={FornecedorOptions}
                            handleSearch={(value: string) =>
                                handleSearchFornecedor(value, 'dadosGerais.fornecedorId')
                            }
                            onSelectValue={handleAutoCompleteSelectedFornecedor}
                        />
                        <InputMoney
                            label={'Valor'}
                            className={'col-span-2'}
                            name={'dadosGerais.valorTotal'}
                            value={values?.dadosGerais?.valorTotal}
                            handleChange={handleChange}
                        // handleBlur={handleBlur}
                        // error={touched?.NfeValorTotalNf && errors?.NfeValorTotalNf ? errors?.NfeValorTotalNf : ''}
                        // hasError={!!(touched?.NfeValorTotalNf && errors?.NfeValorTotalNf)}
                        />
                        <InputDate
                            label='Data Emissão'
                            className='col-span-2'
                            name='dadosGerais.dataEmissao'
                            handleChange={handleChange}
                            value={values?.dadosGerais?.dataEmissao}
                        // handleBlur={handleBlur}
                        // hasError={!!(touched.NfeDataEmissao && errors.NfeDataEmissao)}
                        />
                        <InputDate
                            label='Data de Referência'
                            className='col-span-2'
                            name='dadosGerais.dataReferencia'
                            handleChange={handleChange}
                            value={values?.dadosGerais?.dataReferencia}
                        // handleBlur={handleBlur}
                        // hasError={!!(touched.NfeDataEmissao && errors.NfeDataEmissao)}
                        />
                        {/* <Input
                        label='Forma de Pagamento'
                        className='col-span-6'
                        name='dadosGerais.formaPagamento'
                        handleChange={handleChange}
                        value={values?.dadosGerais?.formaPagamento}
                    /> */}
                        <SelectAutoCompleteComponent
                            label={'Forma de Pagamento *'}
                            value={activeFormaPagamentoSelected?.fpg_descricao ?? ''}
                            className={'col-span-6'}
                            name={'dadosGerais.fpg_Descricao'}
                            options={FormaPagamentoOptions}
                            handleSearch={(value: string) =>
                                handleSearchFormaPagamento(value, 'dadosGerais.formaPagamentoId')
                            }
                            onSelectValue={handleAutoCompleteSelectedFormaPagamento}
                        />
                        <SelectAutoCompleteComponent
                            label={'Condição de Parcelamento *'}
                            value={activeCondicaoParcelamentoSelected?.cpg_descricao ?? ''}
                            className={'col-span-6'}
                            name={'search'}
                            options={CondicaoParcelamentoOptions}
                            handleSearch={(value: string) =>
                                handleSearchCondicaoParcelamento(value, 'dadosGerais.condicaoParcelamentoId')
                            }
                            onSelectValue={handleAutoCompleteSelectedCondicaoParcelamento}
                        />

                        {/* <InputSelect
                        label='Condição de Pagamento'
                        name='dadosGerais.condicaoParcelamentoId'
                        className='col-span-6'
                        handleChange={handleChange}
                        items={CondicaoParcelamentoOptions}
                        helperText={
                            touched?.dadosGerais?.condicaoParcelamentoId &&
                            errors?.dadosGerais?.condicaoParcelamentoId
                              ? errors?.dadosGerais?.condicaoParcelamentoId
                              : ''
                          }
                          error={
                            !!(
                              touched?.dadosGerais?.condicaoParcelamentoId &&
                              errors?.dadosGerais?.condicaoParcelamentoId
                            )
                          }
                          value={values?.dadosGerais?.condicaoParcelamentoId ?? ''}                          
                    //handleBlur={handleBlur}
                    /> */}

                        <Button
                            title={'Calcular Parcelas'}
                            className='col-span-6'
                            variant={'primary'}
                            onClick={() => handleCalculaParcelas(values, 'dadosGerais.valorTotal')}
                            disabled={duploClick}
                        />

                        <Box className='col-span-12 py-4 pt-4'>
                            <div className='flex justify-center'>
                                <Typography variant="h6" component="h2" className='col-span-6 gap-left-8'>
                                    Parcelas
                                </Typography>
                            </div>
                            <Divider className={'col-span-12'} />
                            <DataTable
                                hideFooter={true}
                                height={'25vh'}
                                columns={COLUMNS}
                                rows={values.parcelas.map((item: any, index: number) => {
                                    return {
                                        ...item,
                                        id: index,
                                    };
                                })}
                                showFilter={false}
                                showButtonToXlsx={false}
                            />
                        </Box>
                        <Input
                            label='Observação'
                            className='col-span-12'
                            name='dadosGerais.observacao'
                            handleChange={handleChange}
                            value={values?.dadosGerais?.observacao}
                        />

                        <Box className='col-span-6 flex'>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={(values?.dadosGerais?.repetir && values?.parcelas?.length === 1) || false}
                                    name='dadosGerais.repetir'
                                    disabled={values?.parcelas?.length !== 1 || !!values?.dadosGerais?.cp_id}
                                    onChange={(event) =>
                                        setFieldValue(
                                            'dadosGerais.repetir',
                                            event.target.checked
                                        )
                                    }
                                />
                            }
                            label="Repetir"
                        />
                        { values?.dadosGerais?.repetir && values?.parcelas?.length === 1 && (
                            <FormControl size="small">
                                <InputLabel>Repetir x Vezes</InputLabel>
                                <Select
                                    value={values?.dadosGerais?.repetirValue}
                                    label="Repetir x Vezes"
                                    onChange={(e: SelectChangeEvent) => setFieldValue('dadosGerais.repetirValue', e.target.value)}
                                    style={{ minWidth: '200px' }}
                                >
                                    {Array(11).fill(0).map((_, i) => <MenuItem key={`menu-item-repetir-${i}`} value={i + 2}>{i + 2}x Vezes</MenuItem>)}
                                </Select>
                            </FormControl>
                        )}
                        </Box>
                        { /*
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={values?.dadosGerais?.tituloPago || false}
                                    name='dadosGerais.tituloPago'
                                    onChange={(event) =>
                                        setFieldValue(
                                            'dadosGerais.tituloPago',
                                            event.target.checked
                                        )
                                    }
                                />
                            }
                            label="Marcar Título Como Pago?"
                            className='col-span-5'
                        />
                        
                        <Input
                            label='Simular Condição de Parcelamento'
                            className='col-span-12'
                            name='dadosGerais.simularCondicaoParcelamento'
                            value={values?.dadosGerais?.simularCondicaoParcelamento}
                        />
                        */ }
                    </Box>
                </fieldset>
            </form>
        </TabPanel>
    )
}